import React from 'react';

const ErrorMessage = ({ message }) => {
  return <div className=" text-red-400">{message}</div>;
};

export default ErrorMessage;
